/* eslint-disable react-hooks/exhaustive-deps */
import { LoadingButton } from '@mui/lab';
import {
    Box,
    Button,
    Chip,
    Divider,
    Grid,
    Paper,
    Stack,
    Typography
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { Formik } from 'formik';
import { get, identity, isEmpty, map, pickBy, find } from "lodash";
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

import { Alert, Notification, AutoComplete, InputText, Skeleton } from '../../../components/form';
import { useCanView } from "../../../config/hook/UserPermissions";
import LogsModal from "./LogsModal";
import HistoryIcon from '@mui/icons-material/History';
import { getLog } from "../../../store/config/thunk/log/getAll";
import validator from "./validator";

import { getInvoiceProviderId } from "../../../store/transactions/thunk/invoiceProvider/getId";
import { putInvoiceProvider } from "../../../store/transactions/thunk/invoiceProvider/put";
import { getProvider } from "../../../store/masters/thunk/provider/getAll";

const NewEdit = ({ setBtns, isEdit }) => {
    const formikRef = useRef();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [__] = useTranslation("invoiceProvider");
const { id } = useParams();
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })
    const [isMount, setIsMount] = useState(false);
    const canView = useCanView();
    const [openModalLog, setOpenModalLog] = useState(false);

    const current = useSelector(state => state.transactions.invoiceProvider.detail);
    const put = useSelector(state => state.transactions.invoiceProvider.put);
    const provider = useSelector(state => state.masters.provider);

    const invoiceStatus = __(`invoiceStatus`, { returnObjects: true });

    const invoiceProvider = get(current, "data.idProvider")
        ? [{ value: get(current, "data.idProvider"), label: `${get(current, "data.idProvider")} - ${get(current, "data.providerName")}` }]
        : [];

    const providersList = map(
        get(provider, "data.data", []).filter(p =>
            get(p, "isActive") === true &&
            get(p, "id") !== get(current, "data.idProvider")
        ),
        ({ id, comercialName, legalName }) => ({
            value: id,
            label: `${id} - ${comercialName} - ${legalName}`,
        })
    );

    const clients = [...invoiceProvider, ...providersList];

    const getDataClient = () => {
        let Screen = "FACTURACION PROVEEDOR"
        dispatch(getLog({page: 1, docId: Number(id), screen: String(Screen)}))
        dispatch(getInvoiceProviderId({ id }))
        dispatch(getProvider({ Export: true }))
    }

    const reload = () => {getDataClient();}

    useEffect(() => {
        getDataClient();
    }, []);

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const setError = (err, action) => {
        if (!isEmpty(err) && !!get(err, "Message", "")) {
            setAlert({
                open: true,
                title: get(err, "Message", ""),
                subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        } else {
            setAlert({
                open: true,
                type: "default",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }

    useEffect(() => {
        if (get(put, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }); }
        if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
    }, [put])

    const onSubmit = (values) => {
        if (canView("TRANSACCIONES/FACTURACIÓN PROVEEDOR", "update")) {
            const body = {
                providersTrackingId: Number(id),
                idProvider: Number(get(values, "idClient")),
                comments: get(values, "comments")
            }
            dispatch(putInvoiceProvider(body))
        } else {
            setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para actualizar la factura del proveedor.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }

    const initialValues = {
        idClient: id ? get(current, "data.idProvider", "") : "",
        comments: id ? get(current, "data.comments", "") : ""
    }

    useEffect(() => {
        setBtns(
            <Stack className='mr-6' direction="row" spacing={2} justifyContent="flex-end">
                <Button
                    className="w-[150px] min-w-[150px]"
                    variant="outlined"
                    color="secondary"
                    startIcon={< HistoryIcon/>}
                    onClick={() => {
                        if (canView("TRANSACCIONES/FACTURACIÓN PROVEEDOR/LOGS", "watch")) {
                            setOpenModalLog(true)
                        } else {
                            setAlert({
                                open: true,
                                title: "Permiso Denegado.",
                                subtitle: (<ul> • No tienes permiso para ver las modificaciones en facturación proveedor.</ul>),
                                type: "error",
                                btn: __(`${module}.actions.close`),
                                func: closeAlert
                            })
                        }
                    }}
                    // disabled={get(put, "isLoading")}
                    >
                    Ver Cambios
                </Button>
                {isEdit && <LoadingButton startIcon={<SaveIcon/>} className='w-[100px] min-w-[100px]' variant="contained" color="secondary" type="submit" form="form-invoice" loading={get(put, "isLoading")}>{id ? __(`action.save`) : __(`action.new`)}</LoadingButton>}
                <Button className='w-[100px] min-w-[100px]' variant='outlined' color="secondary" onClick={() => navigate("/transactions/invoiceProvider")} disabled={get(put, "isLoading")} >{__(`action.cancel`)}</Button>
            </Stack>
        )
    }, [get(put, "isLoading")])

    return (
        <div>
            {(get(current, "isLoading")) && !isMount
                ? (
                    <Skeleton />
                ) : (
                    <Formik enableReinitialize innerRef={formikRef} initialValues={initialValues} validationSchema={validator(__)} onSubmit={onSubmit}>
                        {formik => (
                            <form id="form-invoice" onSubmit={get(formik, "handleSubmit")}>
                                <Paper className='mt-4'>
                                    <Box className='p-4' >
                                        <Grid container spacing={{ xs: 2, md: 3 }}>
                                            <Grid item xs={12} sm={6} md={6} >
                                                <Stack direction="row" spacing={1} justifyContent="flex-start" alignItems="center">
                                                    <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                                                    <Typography component="h6" variant="h6">- {get(current, "data.providersTrackingId", "-")}</Typography>
                                                    <Chip label={get(find(invoiceStatus, ({ value }) => value === get(current, "data.statusId", 1)), "label")} sx={{ bgcolor: `${get(find(invoiceStatus, ({ value }) => value === get(current, "data.statusId", 1)), "color")}26`, color: get(find(invoiceStatus, ({ value }) => value === get(current, "data.statusId", 1)), "color") }} />    
                                                </Stack>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={6}>
                                                <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
                                                {get(current, "data.internalOdooOC") ? (
                                                    <>
                                                        <Typography component="h6" variant="h6">Bitacora OC: </Typography>
                                                        <RequestQuoteIcon color="success" />
                                                        <Typography component="h6" variant="h6">{get(current, "data.internalOdooOC", "-")}</Typography>
                                                    </>
                                                ) : <div />}
                                                </Stack> 
                                            </Grid>
                                        </Grid>
                                    </Box>    
                                    <Divider />
                                    <Box className='p-4' >
                                        <Grid container spacing={{ xs: 2, md: 3 }}>
                                            <Grid item xs={12} sm={6} md={6} >
                                                <AutoComplete
                                                    name={"idClient"}
                                                    formik={formik}
                                                    label={__(`form.idClient.label`)}
                                                    placeholder={__(`form.idClient.placeholder`)}
                                                    disabled={!isEmpty(get(current, "data.detail")) || get(current, "isLoading", false) || get(put, "isLoading", false)}
                                                    options={clients}
                                                    reload={getDataClient}
                                                    loading={get(provider, "isLoading")}
                                                    setIsMount={setIsMount}
                                                    {...(isEmpty(get(current, "data.detail")) ? {} : { inputProps: { helperText: __("labels.2") } })}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={6}>
                                                <InputText
                                                    formik={formik}
                                                    name="comments"
                                                    label={__(`form.comments.label`)}
                                                    placeholder={__(`form.comments.placeholder`)}
                                                    disabled={get(current, "isLoading", false)}
                                                    multiline
                                                    rows={4}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Paper>
                            </form>
                        )}
                    </Formik>
                )}
            <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
            <LogsModal
                __={__}
                open={openModalLog}
                close={() => setOpenModalLog(false)}
            />
            <Alert
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
        </div>
    )
}

export default NewEdit
